
module.exports = {
    none: "none",
    login: "loginPage",
    changePassword: "changePasswordPage",
    verifyPhone: "verifyPhonePage",
    settings: "settingsPage",
    winLobby: "winLobbyPage",
    uniPlay: "uniPlayPage",
    wallet: "walletPage",
    records: "recordsPage",
    store: "storePage",
    register: "registerPage"
};